var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button-group',[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.onReadCache}},[_vm._v("读取缓存\n  ")]),_vm._v(" "),(_vm.cloudCache)?_c('el-button',{staticStyle:{"padding":"7px 10px"},attrs:{"size":"mini","icon":"sj-icon-cloud-download"},on:{"click":_vm.readCloudCache}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f63670f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order-review/components/OrderReviewReadCacheButton.vue
// module id = 2373
// module chunks = 5 34